// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Page_pageWrap__NQxX\\+ .Page_pageHeader__kE9WJ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid var(--border);
  margin-bottom: 16px;
}
.Page_pageWrap__NQxX\\+ .Page_pageHeader__kE9WJ h1 {
  font: var(--h3);
  font-weight: 700;
  color: var(--primary-Text);
  font-family: var(--font-bodoni-72);
}
.Page_pageWrap__NQxX\\+ .Page_pageHeader__kE9WJ .Page_right__6qaT4 {
  display: flex;
  align-items: center;
  gap: 20px;
}
.Page_pageWrap__NQxX\\+ .Page_pageHeader__kE9WJ .Page_right__6qaT4 .Page_date__3NNL- {
  display: flex;
  align-items: center;
  gap: 4px;
}
.Page_pageWrap__NQxX\\+ .Page_pageHeader__kE9WJ .Page_right__6qaT4 .Page_date__3NNL- img,
.Page_pageWrap__NQxX\\+ .Page_pageHeader__kE9WJ .Page_right__6qaT4 .Page_date__3NNL- svg {
  width: 16px;
  height: 16px;
  object-fit: scale-down;
  display: block;
}
.Page_pageWrap__NQxX\\+ .Page_pageHeader__kE9WJ .Page_right__6qaT4 .Page_date__3NNL- span {
  font: var(--body-font-four);
  color: var(--primary-Text);
  display: block;
}
.Page_pageWrap__NQxX\\+ .Page_tableWrap__tHwkQ {
  padding: 0 24px;
}

@media (max-width: 767px) {
  .Page_pageWrap__NQxX\\+ .Page_pageHeader__kE9WJ {
    padding: 16px;
  }
  .Page_pageWrap__NQxX\\+ .Page_pageHeader__kE9WJ .Page_right__6qaT4 {
    gap: 12px;
  }
  .Page_pageWrap__NQxX\\+ .Page_pageHeader__kE9WJ .Page_right__6qaT4 button {
    min-height: 35px;
    padding: 7px 10px;
    font-size: 12px;
    text-align: center;
  }
  .Page_pageWrap__NQxX\\+ .Page_tableWrap__tHwkQ {
    padding: 0 16px;
  }
  .Page_InviteModalInner__8-1Ey .Page_csvAddRow__qjS\\+F button {
    font-size: 12px !important;
  }
}
@media (max-width: 425px) {
  .Page_pageWrap__NQxX\\+ .Page_pageHeader__kE9WJ .Page_right__6qaT4 .Page_date__3NNL- span {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/v2/layout/Page/index.module.scss"],"names":[],"mappings":"AACC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCAAA;EACA,mBAAA;AAAF;AAEE;EACC,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kCAAA;AAAH;AAGE;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AADH;AAGG;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AADJ;AAGI;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AADL;AAII;EACC,2BAAA;EACA,0BAAA;EACA,cAAA;AAFL;AAQC;EACC,eAAA;AANF;;AAUA;EAEE;IACC,aAAA;EARD;EAUC;IACC,SAAA;EARF;EAUE;IACC,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EARH;EAaA;IACC,eAAA;EAXD;EAiBC;IACC,0BAAA;EAfF;AACF;AAoBA;EAKK;IACC,aAAA;EAtBJ;AACF","sourcesContent":[".pageWrap {\r\n\t.pageHeader {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tpadding: 16px 24px;\r\n\t\tborder-bottom: 1px solid var(--border);\r\n\t\tmargin-bottom: 16px;\r\n\r\n\t\th1 {\r\n\t\t\tfont: var(--h3);\r\n\t\t\tfont-weight: 700;\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t\tfont-family: var(--font-bodoni-72);\r\n\t\t}\r\n\r\n\t\t.right {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 20px;\r\n\r\n\t\t\t.date {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 4px;\r\n\r\n\t\t\t\timg,\r\n\t\t\t\tsvg {\r\n\t\t\t\t\twidth: 16px;\r\n\t\t\t\t\theight: 16px;\r\n\t\t\t\t\tobject-fit: scale-down;\r\n\t\t\t\t\tdisplay: block;\r\n\t\t\t\t}\r\n\r\n\t\t\t\tspan {\r\n\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\tdisplay: block;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.tableWrap {\r\n\t\tpadding: 0 24px;\r\n\t}\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\t.pageWrap {\r\n\t\t.pageHeader {\r\n\t\t\tpadding: 16px;\r\n\r\n\t\t\t.right {\r\n\t\t\t\tgap: 12px;\r\n\r\n\t\t\t\tbutton {\r\n\t\t\t\t\tmin-height: 35px;\r\n\t\t\t\t\tpadding: 7px 10px;\r\n\t\t\t\t\tfont-size: 12px;\r\n\t\t\t\t\ttext-align: center;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.tableWrap {\r\n\t\t\tpadding: 0 16px;\r\n\t\t}\r\n\t}\r\n\r\n\t.InviteModalInner {\r\n\t\t.csvAddRow {\r\n\t\t\tbutton {\r\n\t\t\t\tfont-size: 12px !important;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 425px) {\r\n\t.pageWrap {\r\n\t\t.pageHeader {\r\n\t\t\t.right {\r\n\t\t\t\t.date {\r\n\t\t\t\t\tspan {\r\n\t\t\t\t\t\tdisplay: none;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `Page_pageWrap__NQxX+`,
	"pageHeader": `Page_pageHeader__kE9WJ`,
	"right": `Page_right__6qaT4`,
	"date": `Page_date__3NNL-`,
	"tableWrap": `Page_tableWrap__tHwkQ`,
	"InviteModalInner": `Page_InviteModalInner__8-1Ey`,
	"csvAddRow": `Page_csvAddRow__qjS+F`
};
export default ___CSS_LOADER_EXPORT___;
